export default __webpack_public_path__ + "static/content-top-img-d2e017f892752d986e8012ae2067fb36.png";